<div class="flex flex-col">
  <label class="text-sm font-semibold">{{ label }}</label>
  <div class="flex items-center">
    <span class="break-words">{{ getDisplayText() }}</span>
  </div>
</div>
